import script from "./RenameCollection.vue?vue&type=script&setup=true&lang=js"
export * from "./RenameCollection.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__